import React from "react";
/* eslint-disable */
import {
  Box,
  TableBody, TableCell, TableContainer, TableHead, TableRow, Table, TableFooter
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {

  render() {
    const plantingDetails = this.props.plantingDetailsList;
    const data = this.props.searchData;
    const totalValues = this.props.totalValues;

    return (
      <div>
        <div>&nbsp;</div>
        <h3><center><u>Planting Details</u></center></h3>
        <div>&nbsp;</div>
        {/* <h4><left>Group - {data.groupID}</left></h4>
        <h4><left>Fresh Collection Center - {data.operationEntityID}</left></h4>
        <h4><left>Product Category - {data.cropCategoryID}</left></h4>
        <h4><left>Product - {data.cropID}</left></h4>
        <h4><left>From - {data.fromDate}</left></h4>
        <h4><left>To - {data.toDate}</left></h4> */}
        <div>&nbsp;</div>
        <Box minWidth={1050}>
          <TableContainer style={{ marginLeft: '5px' }}>
            <Table aria-label="caption table">
              <TableHead>
                <TableRow>
                  <TableCell align={'left'}>Product Code</TableCell>
                  <TableCell align={'left'}>SKU Description</TableCell>
                  <TableCell align={'left'}>FCC Location</TableCell>
                  <TableCell align={'left'}>Planting Start Date</TableCell>
                  <TableCell align={'right'}>Extent(Acres)</TableCell>
                  <TableCell align={'right'}>Cultivated percentage %</TableCell>
                  <TableCell align={'right'}>Quantity(KG)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {plantingDetails.map((data, index) => (
                  <TableRow key={index}>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.productCode}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.productDescription}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.factoryName}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {new Date(data.startDate).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', minimumIntegerDigits: 2 })}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {parseFloat(data.acres).toFixed(2)}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {parseFloat(data.cultivationPercentage)}
                    </TableCell>
                    <TableCell align='right'>
                      {new Intl.NumberFormat('en-US', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(data.yield)}
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }} colSpan={4}>Total</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="right">{parseFloat(totalValues.totalExtent).toFixed(2)}</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="right"></TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="right">
                    {new Intl.NumberFormat('en-US', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(totalValues.totalQuantity)}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>
    );
  }
}
